import { useTranslation } from 'react-i18next';
import { MarketFdicIcon } from '@squareup/market-react/icons';
import styles from './FdicDisclosure.module.css';

export const FdicDisclosure = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {/* TODO: Replace data-market-icon-name with aria-label for proper accessibility */}
      <MarketFdicIcon data-market-icon-name="fdic" />
      <p data-testid="fdic-description" className={styles.description}>
        {t('bankingShared.fdic')}
      </p>
    </div>
  );
};
